import Cookies from 'universal-cookie/es6';
import { useHistory } from "react-router-dom";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : MenuItems
Description : Componente que contiene la información de los botones de la barra de navegación de la aplicación
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se defienen los botones de la barra de navegación.
2/11/2021 Cristian Andres Pizo Mina – Se modifico las direcciones de /Stactic y /Vacation.
================================================================================ */

export default function MenuItems() {
    let history = useHistory();
    const cookies = new Cookies();
    const items = [
        {
            label: 'Horas extra y recargos',
            path: "/NoveltiesOvertime",
            index: 0,
        },
        {
            label: 'Reportados',
            path: "/NoveltiesReported",
            index: 1,
        },
        {
            label: 'Fijas',
            path: "/NoveltiesStatic",
            index: 2,
        },
        {
            label: 'Vacaciones',
            path: "/NoveltiesVacation",
            index: 3,
        },
        {
            label: 'Ausentismos y licencias',
            path: "/NoveltiesLicenses",
            index: 4,
        }
    ]
    return items
}